import { render } from "./App.vue?vue&type=template&id=cbeaff1e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cbeaff1e&lang=scss"

import exportComponent from "/Users/documedias/gitlab/virtuell/unionconf2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__